import { c as _c } from "react/compiler-runtime";
import './segmented-stepper.scss';
import { cn } from '../../utils/helpers.ts';
type SegmentedStepperProps = {
  count: number;
  activeItem?: number;
  className?: string;
};
export const SegmentedStepper: React.FC<SegmentedStepperProps> = t0 => {
  const $ = _c(8);
  const {
    count,
    activeItem: t1,
    className
  } = t0;
  const activeItem = t1 === undefined ? 0 : t1;
  const t2 = `SegmentedStepper flex mx-auto ${className}`;
  let t3;
  if ($[0] !== count) {
    t3 = Array.from({
      length: count
    });
    $[0] = count;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== activeItem || $[3] !== t3) {
    t4 = t3.map((_, index) => <div key={index} className={cn("SegmentedStepper__item h-full w-full", {
      "SegmentedStepper__item--visited": index < activeItem,
      "SegmentedStepper__item--active": index === activeItem,
      "SegmentedStepper__item--upcoming": index > activeItem
    })} />);
    $[2] = activeItem;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t2 || $[6] !== t4) {
    t5 = <div className={t2}>{t4}</div>;
    $[5] = t2;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
};